/* WISC Cinematic Theme JS v6 */
(function(){
'use strict';

var $=function(s,c){return(c||document).querySelector(s)};
var $$=function(s,c){return(c||document).querySelectorAll(s)};

/* ── Cart drawer ───────────────────────────────────────── */
var cartEl=$('#js-cart'),overlay=$('#js-overlay'),
    openBtn=$('#js-cart-open'),closeBtn=$('#js-cart-close');

function openCart(){
  if(!cartEl)return;
  cartEl.classList.add('open');cartEl.setAttribute('aria-hidden','false');
  if(overlay){overlay.classList.add('open');overlay.setAttribute('aria-hidden','false');}
  document.body.style.overflow='hidden';
}
function closeCart(){
  if(!cartEl)return;
  cartEl.classList.remove('open');cartEl.setAttribute('aria-hidden','true');
  if(overlay){overlay.classList.remove('open');overlay.setAttribute('aria-hidden','true');}
  document.body.style.overflow='';
  closeMobileNav();
}
window.wiscOpenCart=openCart;
if(openBtn)openBtn.addEventListener('click',openCart);
if(closeBtn)closeBtn.addEventListener('click',closeCart);
if(overlay)overlay.addEventListener('click',function(e){if(e.target===overlay){closeCart();}});

/* Cart qty buttons */
document.addEventListener('click',function(e){
  var b=e.target.closest('.qty-btn');if(!b)return;
  var qty=Math.max(0,parseInt(b.dataset.qty)||0);
  fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:b.dataset.key,quantity:qty})})
    .then(function(r){return r.json();})
    .then(function(c){updateCount(c.item_count);window.location.reload();});
});

/* ── Mobile nav ────────────────────────────────────────── */
var burger=$('#js-burger'),mobileNav=$('#js-mobile-nav'),mobileClose=$('#js-mobile-close');
function openMobileNav(){
  if(!mobileNav)return;
  mobileNav.classList.add('open');mobileNav.setAttribute('aria-hidden','false');
  if(overlay)overlay.classList.add('open');
  document.body.style.overflow='hidden';
  if(burger)burger.setAttribute('aria-expanded','true');
}
function closeMobileNav(){
  if(!mobileNav)return;
  mobileNav.classList.remove('open');mobileNav.setAttribute('aria-hidden','true');
  document.body.style.overflow='';
  if(burger)burger.setAttribute('aria-expanded','false');
}
if(burger)burger.addEventListener('click',openMobileNav);
if(mobileClose)mobileClose.addEventListener('click',closeMobileNav);

/* ── Cart count ────────────────────────────────────────── */
function updateCount(n){
  var el=$('#js-cart-count');if(!el)return;
  el.textContent=n;el.style.display=n>0?'inline-flex':'none';
}
fetch('/cart.js').then(function(r){return r.json();}).then(function(c){updateCount(c.item_count);}).catch(function(){});

/* ── ATC form ──────────────────────────────────────────── */
var atcForm=$('#js-atc-form');
if(atcForm){
  atcForm.addEventListener('submit',function(e){
    e.preventDefault();
    var btn=$('#js-atc-btn');
    var orig=btn?btn.textContent:'Add to Bag';
    if(btn){btn.disabled=true;btn.textContent='Adding\u2026';}
    var fd=new FormData(atcForm);
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:fd.get('id'),quantity:parseInt(fd.get('quantity'))||1})
    })
    .then(function(r){return r.json();})
    .then(function(){return fetch('/cart.js').then(function(r){return r.json();});})
    .then(function(c){
      updateCount(c.item_count);openCart();
      if(btn){btn.disabled=false;btn.textContent=orig;}
    })
    .catch(function(){
      if(btn){btn.disabled=false;btn.textContent=orig;}
      window.location.href='/cart';
    });
  });
}

/* ── Product page ──────────────────────────────────────── */
var variants=window.__wisc_v,selectedOpts=window.__wisc_o;
if(variants&&selectedOpts){

  /* Thumbnail clicks */
  $$('.product-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      $$('.product-thumb').forEach(function(x){x.classList.remove('active');});
      this.classList.add('active');
      var m=$('#js-main-img');
      if(m){m.classList.remove('zoomed');m.src=this.dataset.src;}
    });
  });

  /* Zoom toggle */
  var mainImg=$('#js-main-img');
  if(mainImg)mainImg.addEventListener('click',function(){this.classList.toggle('zoomed');});

  /* Qty +/- */
  $$('.qty-wrap__btn').forEach(function(b){
    b.addEventListener('click',function(){
      var inp=$('#js-qty');if(!inp)return;
      var v=parseInt(inp.value)||1;
      if(this.dataset.action==='plus')inp.value=v+1;
      if(this.dataset.action==='minus'&&v>1)inp.value=v-1;
    });
  });

  /* Swatch selection */
  $$('.swatch').forEach(function(s){
    s.addEventListener('click',function(){
      var idx=parseInt(this.dataset.idx),val=this.dataset.val;
      selectedOpts[idx]=val;
      var lbl=$('#js-opt-'+idx);if(lbl)lbl.textContent=val;
      var row=this.closest('.swatches');
      if(row)$$('.swatch',row).forEach(function(x){x.classList.remove('active');});
      this.classList.add('active');
      var match=variants.find(function(v){return v.options.every(function(o,i){return o===selectedOpts[i];});});
      if(!match)return;
      /* Update hidden input */
      var vid=$('#js-variant-id');if(vid)vid.value=match.id;
      /* Update price */
      var pe=$('#js-price');
      if(pe){
        var fmt=function(c){return new Intl.NumberFormat('en-CA',{style:'currency',currency:'CAD'}).format(c/100);};
        pe.innerHTML=(match.compare_at_price>match.price?'<s>'+fmt(match.compare_at_price)+'</s> ':'')+fmt(match.price);
      }
      /* Update button */
      var ab=$('#js-atc-btn');
      if(ab){
        ab.disabled=!match.available;
        ab.textContent=match.available?(ab.dataset.add||'Add to Bag'):(ab.dataset.sold||'Sold Out');
      }
      /* Swap image */
      if(match.featured_image){var mi=$('#js-main-img');if(mi){mi.src=match.featured_image.src;mi.classList.remove('zoomed');}}
      /* Mark unavailable swatches */
      $$('.swatch').forEach(function(sw){
        var test=selectedOpts.slice();test[parseInt(sw.dataset.idx)]=sw.dataset.val;
        var ok=variants.some(function(v){return v.available&&v.options.every(function(o,i){return o===test[i];});});
        sw.classList.toggle('na',!ok);
      });
    });
  });
}

/* ── Accordion ─────────────────────────────────────────── */
$$('.accordion__trigger').forEach(function(t){
  t.addEventListener('click',function(){
    var item=this.closest('.accordion__item');
    var body=item.querySelector('.accordion__body');
    var open=item.classList.contains('open');
    $$('.accordion__item').forEach(function(i){
      i.classList.remove('open');
      i.querySelector('.accordion__body').style.maxHeight='0';
    });
    if(!open){item.classList.add('open');body.style.maxHeight=body.scrollHeight+'px';}
  });
});

/* ── Scroll reveal ─────────────────────────────────────── */
var ro=new IntersectionObserver(function(entries){
  entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('on');ro.unobserve(e.target);}});
},{threshold:.1,rootMargin:'0px 0px -30px 0px'});
$$('.reveal').forEach(function(el){ro.observe(el);});

/* ── Manifesto stagger ─────────────────────────────────── */
var mo=new IntersectionObserver(function(entries){
  entries.forEach(function(e){
    if(e.isIntersecting){
      $$('.manifesto__word',e.target).forEach(function(w,i){setTimeout(function(){w.classList.add('lit');},i*160);});
      mo.unobserve(e.target);
    }
  });
},{threshold:.2});
var man=$('.manifesto');if(man)mo.observe(man);

/* ── Hero parallax (desktop only) ─────────────────────── */
var hp=$('.hero__product');
if(hp&&window.innerWidth>768){
  window.addEventListener('scroll',function(){
    hp.style.transform='translateY('+(window.scrollY*.09)+'px)';
  },{passive:true});
}

/* ── Marquee pause ─────────────────────────────────────── */
var mq=$('.marquee');
if(mq){
  mq.addEventListener('mouseenter',function(){this.style.animationPlayState='paused';});
  mq.addEventListener('mouseleave',function(){this.style.animationPlayState='running';});
}

})();